import { AddCseInput } from '../../lib/types/models/cse/cse'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function addCseToEnrollment(input: AddCseInput) {
  const { enrollmentId, ...data } = input
  return restApiClient
    .url(constructApiUrl(API.enrollments.addCse.url, { id: enrollmentId }))
    .post<void, Omit<AddCseInput, 'enrollmentId'>>(data)
}
